import * as React from "react";
import Lottie from "react-lottie";
const animationData = require("../assets/loading_ribbon.json");

export default class LottieControl extends React.Component<{ text?: string }> {
  state = { isStopped: false, isPaused: false };

  render() {
    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
      }
    };

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          marginTop: 24
        }}
      >
        <Lottie
          options={defaultOptions}
          height={150}
          width={200}
          isStopped={this.state.isStopped}
          isPaused={this.state.isPaused}
        />
        <div style={{ textAlign: "center" }}>
          {this.props.text ? this.props.text : "Loading"}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/loading.tsx